import styled from 'styled-components';

export const FlexBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'flex-start'};
  ${(props) => props.itemsAlign && `align-items: ${props.itemsAlign}`};
  ${(props) => props.width && `width: ${props.width}`};
`;



// WEBPACK FOOTER //
// ./resources/assets/js/containers/PressureGraph/style.js